/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uDashboard = A4uDashboard;

var _react = _interopRequireDefault(require("react"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function A4uDashboard(_ref) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 'M' : _ref$scale,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'LIGHT' : _ref$color,
      props = _objectWithoutProperties(_ref, ["scale", "color"]);

  return _react["default"].createElement("svg", _extends({
    viewBox: _util.viewBoxes[scale]
  }, props, props), _react["default"].createElement("path", {
    d: "M7.324 28.053a13.27 13.27 0 0 1-2.656-7.794A13.483 13.483 0 0 1 17.612 6.741a13.331 13.331 0 0 1 11.064 21.312.725.725 0 0 0 .1 1l.931.775a.733.733 0 0 0 1.048-.107 16 16 0 1 0-25.515 0 .729.729 0 0 0 1.045.107l.932-.776a.724.724 0 0 0 .107-.999z"
  }), _react["default"].createElement("path", {
    d: "M20.839 23.526a2.909 2.909 0 1 1-3.474-2.2c.748-.167 5.534-6.2 6.146-5.845.673.39-2.855 7.225-2.672 8.045z"
  }), _react["default"].createElement("circle", {
    cx: 7.818,
    cy: 20.069,
    r: 1.6
  }), _react["default"].createElement("circle", {
    cx: 10.727,
    cy: 12.796,
    r: 1.6
  }), _react["default"].createElement("circle", {
    cx: 25.273,
    cy: 12.796,
    r: 1.455
  }), _react["default"].createElement("circle", {
    cx: 18,
    cy: 9.887,
    r: 1.455
  }), _react["default"].createElement("circle", {
    cx: 28.182,
    cy: 20.069,
    r: 1.455
  }));
}